import React from 'react';

import logo from '../images/logo.png';

function Header() {
  return (
    <div className="header">
      <div className="header__brand">
        <img alt="Madam Curious" src={logo} />
      </div>
    </div>
  )
}

export default Header;
